import type { LocaleString } from '@dreamstack/i18n'

export type AccessFileType = 'homeOwnership' | 'housingCost' | 'capitalGuide'
type AccessUrlType = 'registration' | 'redirect'

const urlTranslations = {
  homeOwnership: {
    registration: {
      de: '/wohneigentumsreport-anmeldung',
      en: '/en/homeownership-report-register',
    },
    redirect: {
      de: '/wohneigentumsreport',
      en: '/en/homeownership-report',
    },
  },
  housingCost: {
    registration: {
      de: '/wohnkostenreport-anmeldung',
      en: '/en/housing-cost-report-register',
    },
    redirect: {
      de: '/wohnkostenreport',
      en: '/en/housing-cost-report',
    },
  },
  capitalGuide: {
    registration: {
      de: '/kapitalanlagen-guide-anmeldung',
      en: '/en/investments-guide-registration',
    },
    redirect: {
      de: '/kapitalanlagen-guide',
      en: '/en/investments-guide',
    },
  },
}

export const getAccessFileUrls = (
  locale: LocaleString,
  optInActionType: AccessFileType,
  urlType: AccessUrlType
) => {
  const url = urlTranslations[optInActionType][urlType][locale]

  return url
}
